var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#53CBC9",
    d: "M8.143 9.986a4.886 4.886 0 0 1 4.929-4.843A4.885 4.885 0 0 1 18 9.986a.3.3 0 0 1-.3.3H8.443a.3.3 0 0 1-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB1F7A",
    d: "M6.857 11.571c0-.235.159-.428.356-.428h11.289c.197 0 .355.193.355.428c0 .236-.158.429-.355.429H7.213c-.197 0-.356-.193-.356-.429m-2.143 1.286c0-.236.163-.428.36-.428h8.28c.198 0 .36.192.36.428s-.162.429-.36.429h-8.28c-.197 0-.36-.193-.36-.429m2.503.857c-.197 0-.36.193-.36.429s.163.428.36.428h9.995c.197 0 .36-.192.36-.428s-.163-.429-.36-.429zm-2.074 1.714c0-.235.167-.428.369-.428h3.977c.201 0 .368.193.368.428c0 .236-.167.43-.368.43H5.512c-.202 0-.369-.194-.369-.43m7.204.858c-.193 0-.347.192-.347.428s.154.429.347.429h4.882c.193 0 .347-.193.347-.429c0-.235-.154-.428-.347-.428h-4.886zM9 18c0-.236.154-.429.347-.429h4.882c.193 0 .347.193.347.429s-.154.428-.347.428H9.343c-.193 0-.347-.192-.347-.428zm1.65-3c-.201 0-.364.193-.364.428c0 .236.163.43.364.43h8.272c.201 0 .364-.194.364-.43c0-.235-.163-.428-.364-.428zm-5.078-3.43a.429.429 0 1 1 .857 0a.429.429 0 0 1-.857 0m-1.715.857a.428.428 0 1 0 0 .857a.428.428 0 0 0 0-.857m1.715 1.715a.429.429 0 1 1 .857 0a.429.429 0 0 1-.857 0M4.286 15a.429.429 0 1 0 0 .858a.429.429 0 0 0 0-.858m6.428 1.714a.428.428 0 1 1 .857 0a.428.428 0 0 1-.857 0m-2.571.857a.429.429 0 1 0 0 .857a.429.429 0 0 0 0-.857"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlmr);
export default __webpack_public_path__ + "static/media/glmr.42797a90826c88c8e981b3dac6adc455.svg";
export { ForwardRef as ReactComponent };